export const API_URL = "https://webcontroller.sangeetasletslearn.academy/api";
// export const API_URL = "https://lla.chakit.me/api";
// export const API_URL = "http://localhost:5002/api";